import { AnimatePresence, motion } from "framer-motion";
import type { VoiceItemTypes } from "../../../../../utils/types";
import style from "./NewVoice.module.scss";
import VoiceItem from "./VoiceItem";

interface Props {
	selected: string;
	onClick: (value: string) => void;
	items: {
		value: string;
		description?: string;
		preview_url?: string;
		useCase?: string;
		temper?: string;
	}[];
}

const renderDropList: React.FC <Props>  = ({
	selected,
	onClick,
	items,
}) => {
	return (
		<AnimatePresence>
			{items.length > 0 && (
				<motion.div
					className={`${style.dropdownList}`}
					exit={{ height: 0 }}
					initial={{ opacity: 0 }}
                    animate={{ height: "194px", opacity: 1 }}
                    transition={{ duration: 0.4 }}
					onClick={(e) => e.stopPropagation()}
				>
					<div className={style.scrollBar} />
					{items.map((el, index) =>
						<VoiceItem
							key={el.value}
							{...(el as VoiceItemTypes)}
							active={el.value === selected}
							onClick={onClick}
							index={index + 1}
						/>
					)}
				</motion.div>
			)}
		</AnimatePresence>
	);
};

export default renderDropList;
